export const ITEM_LIST_BUTTON = 'itemlistbutton';
export const ITEM_LIST_COUNTER = 'itemlistcounter';
export const ITEM_LIST_NEW = 'itemlistnew';
export const LIST_ITEM_LOCAL_KEY = 'blaze_item_list_';
export const LIST_ITEM_QUERY_PARAM = 'itemListId';
//# sourceMappingURL=constants.js.map